import type { ReactElement } from 'react';
import cx from 'clsx';
import { FieldError, type FieldErrorProps } from 'react-aria-components';
import styles from './error.module.css';

export function Error({ className, ...props }: FieldErrorProps): ReactElement {
  return (
    // FieldError strips role/aria-live via filterDOMProps, so a live-region wrapper is
    // needed to announce errors on appearance (WCAG 4.1.3). aria-live (not role="alert")
    // avoids declaring every field error an alert widget, which collides with page-level
    // getByRole('alert') in consumers.
    <span aria-atomic="true" aria-live="assertive" className={styles.liveRegion}>
      <FieldError
        className={cx(className, styles.error, 'caption')}
        data-test-form-elements-message
        data-test-level="error"
        {...props}
      />
    </span>
  );
}
